export const setupRoutes = [
  {
    name: 'setup',
    path: '/setup',
    component: () => import('@/modules/setup/views/Setup.vue'),
    meta: { redirect: false }
  },
  {
    name: 'installation',
    path: '/installation',
    component: () => import('@/modules/setup/views/Installation.vue')
  }
]
